import { getString } from "../../common/common";

export const NAME = 'Name';
export const MOBILE_NUMBER = 'Mobile_Number';
export const GENDER = 'Gender';
export const YEAR = 'Year';
export const MONTH = 'Month';
export const DAY = 'Day';
export const MALE = 'Male';
export const FEMALE = 'Female';
export const OTHER = 'Other';
export const NATION = 'Nationality';
export const IND = 'Indian';
export const ADDRESS = 'Address';
export const CITY = 'City';
export const COUNTRY_CODE = 'CountryCode';
export const STATE = 'state';
export const POST_CODE = 'postal_code';
export const ID_CARD = 'select_id_card';
export const AADHAR_CARD = 'Aadhar_Card';
export const PAN_CARD = 'Pan_Card';
export const ID_NUM = 'ID_Number';
export const GSTIN = 'GSTIN';
export const EMAIL = 'Email';
export const UPDATE_PROFILE = 'update profile';

export const ENTER_OTP = "ENTER_OTP";
export const VERIFY = "VERIFY";
export const RESEND_OTP_IN = "RESEND_OTP_IN";
export const RESEND_OTP_NOW = "RESEND_OTP_NOW";
export const ENTER_VALID_OTP = "ENTER_VALID_OTP";


export const translations = {
    en: {
        [NAME]: "Name",
        [MOBILE_NUMBER]: "Mobile Number",
        [GENDER]: "Gender",
        [YEAR]: "Year",
        [MONTH]: "Month",
        [DAY]: "Day",
        [MALE]: "Male",
        [FEMALE]: "Female",
        [OTHER]: "Other",
        [NATION]: "Nationality",
        [IND]: "Indian",
        [ADDRESS]: "Address",
        [CITY]: 'City',
        [COUNTRY_CODE]: 'Country Code',
        [STATE]: 'state',
        [POST_CODE]: 'postal code',
        [ID_CARD]: 'select id card',
        [AADHAR_CARD]: 'Aadhar Card',
        [PAN_CARD]: 'Pan Card',
        [ID_NUM]: 'ID Number',
        [GSTIN]: 'GSTIN',
        [EMAIL]: 'Email',
        [UPDATE_PROFILE]: 'Update Profile',
        [ENTER_OTP]: "Enter OTP (One Time Password) ",
        [VERIFY]: "Verify",
        [RESEND_OTP_IN]: "Resend Otp in ",
        [RESEND_OTP_NOW]: "Resend the OTP now",
        [ENTER_VALID_OTP]: "Please enter Valid otp",
    },
    kn: {
        [NAME]: "ಹೆಸರು",
        [MOBILE_NUMBER]: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ.",
        [GENDER]: "ಲಿಂಗ",
        [YEAR]: "ವರ್ಷ",
        [MONTH]: "ತಿಂಗಳು",
        [DAY]: "ದಿನ",
        [MALE]: "ಪುರುಷ",
        [FEMALE]: "ಹೆಣ್ಣು",
        [OTHER]: "ಇತರೆ",
        [NATION]: "ರಾಷ್ಟ್ರೀಯತೆ",
        [IND]: "ಭಾರತೀಯ",
        [ADDRESS]: "ವಿಳಾಸ",
        [CITY]: 'ನಗರ',
        [COUNTRY_CODE]: 'ದೇಶದ ಕೋಡ್',
        [STATE]: 'ರಾಜ್ಯ',
        [POST_CODE]: 'ಪೋಸ್ಟಲ್ ಕೋಡ್',
        [ID_CARD]: 'ಐಡಿ ಕಾರ್ಡ್ ಆಯ್ಕೆಮಾಡಿ',
        [AADHAR_CARD]: 'ಆಧಾರ್ ಕಾರ್ಡ್',
        [PAN_CARD]: 'ಪ್ಯಾನ್ ಕಾರ್ಡ್',
        [ID_NUM]: 'ಐಡಿ ಸಂಖ್ಯೆ',
        [GSTIN]: 'GSTIN', //todo
        [EMAIL]: 'ಇಮೇಲ್',
        [UPDATE_PROFILE]: 'ಪ್ರೊಫೈಲ್ ಅಪ್ಡೇಟ್ ಮಾಡಿ',
        [ENTER_OTP]: "OTP (ಒನ್ ಟೈಮ್ ಗುಪ್ತಪದ) ಎಂಟರ್ ಮಾಡಿ",
        [VERIFY]: "ಪರಿಶೀಲಿಸಿ",
        [RESEND_OTP_IN]: "OTP ಅನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಿ",
        [RESEND_OTP_NOW]: "ಈಗ OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
        [ENTER_VALID_OTP]: "ದಯವಿಟ್ಟು ಸರಿಯಾದ OTPಯನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    },
};

export const t = (key = "") => {
    return getString(key, translations)
}